module.exports = __webpack_public_path__ + "static/media/46.82db6fde.png";